import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import isEmpty from 'lodash/isEmpty';

import Input from '../../../common/input';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';

const PaymentSettings = ({ handleSubmit, submitting, pristine, valid, shopId, barbers, barberId }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={submitting}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item">
                  <div className="c-label-new">Connected Account Id</div>
                  <Input className="c-input" name="managedAccountId" type="text" placeholder="Connected Account Id" />
                </div>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <AdminActionButton
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">Save</span>
              </AdminActionButton>
            </div>
          </fieldset>
        </form>
      </div>
      <div className="c-inner-wrapper u-mt" display-if={!isEmpty(barbers) && !barberId}>
        <div className="c-heading">Set connected account for barber</div>
        <ul className="list-bare">
          {barbers.map(barber => (
            <li key={barber.id}>
              <Link to={`/admin/shops/${shopId}/payment/${barber.id}`}>
                {barber.firstName} {barber.lastName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
PaymentSettings.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  shopId: PropTypes.string.isRequired,
  barberId: PropTypes.string.isRequired,
  barbers: PropTypes.array,
};
PaymentSettings.defaultProps = {
  barbers: [],
};

export default PaymentSettings;
